import { useTranslation } from 'react-i18next'

import styles from './OrderDetailPanel.module.scss'

const OrderDetailPanel = ({
  drawer,
  busy,
  onSubmit,
  onSign,
  onPdf,
  onDelete,
  onDecide,
}) => {
  const { t } = useTranslation('common')

  return (
    <>
      <div className={styles.meta}>
        <div>{t('ordersPage.studentLbl')} <b>{drawer.student_label}</b></div>
        <div>{t('ordersPage.typeLbl')} {drawer.kind_display}</div>
        <div>{t('ordersPage.dateLbl')} {drawer.issued_at}</div>
        <div>
          {t('ordersPage.statusLbl')}{' '}
          <span className={`${styles.badge} ${styles[`s_${drawer.status}`]}`}>
            {drawer.status_display}
          </span>
        </div>
      </div>
      <div className={styles.body}>
        <h4>{t('ordersPage.bodyTitle')}</h4>
        <pre>{drawer.body}</pre>
        {drawer.reason && (
          <p><b>{t('ordersPage.reasonInline')}</b> {drawer.reason}</p>
        )}
        {drawer.signature_digest && (
          <p className={styles.digest}>
            {t('ordersPage.signHash')} {drawer.signature_digest.slice(0, 16)}…
          </p>
        )}
      </div>

      <h4>{t('ordersPage.approvals')}</h4>
      <table className={styles.subTable}>
        <thead>
          <tr>
            <th>{t('ordersPage.step')}</th>
            <th>{t('ordersPage.decision')}</th>
            <th>{t('ordersPage.who')}</th>
            <th>{t('ordersPage.actions')}</th>
          </tr>
        </thead>
        <tbody>
          {(drawer.approvals || []).map((a) => (
            <tr key={a.id}>
              <td>{a.role_display}</td>
              <td>{a.decision_display}</td>
              <td>{a.decided_by_label || '—'}</td>
              <td>
                {a.decision === 'pending' && (
                  <>
                    <button
                      className={styles.smallBtn}
                      onClick={() => onDecide(a.role_code, 'approved')}
                    >
                      {t('ordersPage.approve')}
                    </button>
                    <button
                      className={styles.smallBtn}
                      onClick={() => onDecide(a.role_code, 'rejected')}
                    >
                      {t('ordersPage.reject')}
                    </button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className={styles.actions}>
        {drawer.status === 'draft' && (
          <button className="unv-btn" onClick={onSubmit} disabled={busy}>
            {t('ordersPage.submitForApproval')}
          </button>
        )}
        {drawer.status === 'review' && (
          <button className="unv-btn unv-btn--primary" onClick={onSign} disabled={busy}>
            {t('ordersPage.sign2')}
          </button>
        )}
        <button className="unv-btn" onClick={onPdf}>{t('ordersPage.pdf')}</button>
        {drawer.status === 'draft' && (
          <button className="unv-btn unv-btn--danger" onClick={onDelete}>
            {t('ordersPage.delete')}
          </button>
        )}
      </div>
    </>
  )
}

export default OrderDetailPanel
